import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["delete"]

  connect() {
    // No initialization needed
  }

  close(event) {
    const notification = event.currentTarget.closest('.notification')
    notification.parentNode.removeChild(notification)
  }
}
